// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const UserTasksGridViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-usertasksgridview" */ "./UserTasksGridView")).then((page)=>{
        return {
            default: page.UserTasksGridView
        };
    });
export const LazyUserTasksGridView = /*#__PURE__*/ lazy(UserTasksGridViewLazyLoader);
